import { Copy } from "lucide-react";
import PrimaryButton from "../../../components/buttons/PrimaryButton";
import { Patient } from "../../../utils/api-objects/Patient";
import { useUserData } from "../../../utils/context/UserDataContext";
import { getExpertSchedulingUrl } from "../../experts/utils/getExpertSchedulingUrl";
import { copyToClipboard } from "../../shared/utils/copyToClipboard";

interface Props {
    patient: Patient;
}

const BookAppointmentBox: React.FC<Props> = ({ patient }) => {
    const { userData } = useUserData();
    const email = userData.email || "";
    const schedulingUrl = getExpertSchedulingUrl(email);

    const handleBookAppointment = () => {
        if (schedulingUrl) {
            window.open(schedulingUrl, "_blank");
        }
    };

    return (
        <div className="space-y-[25px] border rounded-xl p-2 border border-solid border-holifya-grey-shadow shadow-platform-new">
            <div className="font-bold text-[16px] leading-[33px]">
                Prenota un appuntamento
            </div>
            <div className="space-y-[20px]">
                <div className="text-sm">
                    <p className="mb-2">Importante: prima di prenotare, copia i dati del paziente:</p>
                    <div className="space-y-2">
                        <div className="flex items-center">
                            <span className="text-holifya-blue">Email: {patient.email}</span>
                            <div className="relative ml-2 cursor-pointer group">
                                <Copy
                                    onClick={() => copyToClipboard(patient.email)}
                                    className="text-blue-500 hover:text-blue-700 w-4 h-4"
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-[10px] rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 whitespace-nowrap">
                                    Copia email
                                </div>
                            </div>
                        </div>
                        {patient.user_mobile_phone && (
                            <div className="flex items-center">
                                <span className="text-holifya-blue">Telefono: {patient.user_mobile_phone}</span>
                                <div className="relative ml-2 cursor-pointer group">
                                    <Copy
                                        onClick={() => copyToClipboard(patient.user_mobile_phone)}
                                        className="text-blue-500 hover:text-blue-700 w-4 h-4"
                                    />
                                    <div className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-[10px] rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 whitespace-nowrap">
                                        Copia telefono
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <p className="mt-4">Clicca il pulsante qui sotto per prenotare un appuntamento con il paziente</p>
                </div>
                <div className="w-full h-[55px]">
                    <PrimaryButton
                        text="Prenota appuntamento"
                        pointer={!!schedulingUrl}
                        disabled={!schedulingUrl}
                        onClick={handleBookAppointment}
                    />
                </div>
            </div>
        </div>
    );
};

export default BookAppointmentBox; 